<div
  class="form-check {{ type == 'switch' ? 'form-switch' : '' }} ms-2"
  [class.label-top]="labelTop"
  [style.margin-top]="labelTop ? '0' : '0.45rem'"
>
  <div class="d-flex mb-2" [class.flex-column-reverse]="labelTop" [class.align-items-center]="true" [class.justify-content-between]="labelTop">
    <div [class.text-center]="labelTop">
      <input
        *ngIf="type == 'radio'"
        class="form-check-input"
        type="radio"
        [id]="id"
        [name]="name"
        [value]="value"
        [formControl]="control"
      />
      <input
        *ngIf="type == 'checkbox'"
        class="form-check-input"
        type="checkbox"
        [id]="id"
        [value]="value"
        [formControl]="control"
      />
      <input
        *ngIf="type == 'switch'"
        class="form-check-input"
        role="switch"
        type="checkbox"
        [id]="id"
        [value]="value"
        [formControl]="control"
      />
    </div>
    <div>
      <label class="form-check-label mb-0" [for]="id" [injectHTML]="label"> </label>
      <a *ngIf="modal" (click)="open(content)" class="ms-1">
        <i class="fa-solid fa-circle-info text-primary"></i>
      </a>
    </div>
  </div>
  @if(showValidator){
    <app-validator [control]="control" [label]="label"></app-validator>
  }
</div>

<ng-template #content let-modal>
  <app-modal [activeModalInput]="modal">
    <ng-container modal-title>{{ modalTitle }}</ng-container>
    <ng-container modal-body><ng-content></ng-content></ng-container>
    <ng-container modal-footer>
      <app-button (click)="modal.close(null)">Venster sluiten</app-button>
    </ng-container>
  </app-modal>
</ng-template>
